import realpressCompareList from './compare-property/compare-list';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	realpressCompareList();
} );
